import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  Breadcrumbs,
  Button,
  Grid,
  Typography,
  SvgIcon,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { makeStyles } from "@mui/styles";
import { PlusCircle as PlusCircleIcon } from "react-feather";

const useStyles = makeStyles(() => ({
  root: {},
}));

function Header({ className, ...rest }) {
  const classes = useStyles();

  return (
    <Grid
  className={clsx(classes.root, className)}
  container
  justifyContent="space-between"
  alignItems="center"
  spacing={3}
  {...rest}
>
  <Grid item>
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      <Typography
        variant="h3"
        color="textPrimary"
        style={{ marginLeft: "1.5em" }}
      >
        SOCIETY
      </Typography>
    </Breadcrumbs>
  </Grid>

  <Grid item sx={{ marginLeft: "auto" }}>
    <Button
      color="secondary"
      variant="contained"
      className={classes.action}
      component={RouterLink}
      to="/app/management/add/society"
    >
      <SvgIcon
        fontSize="small"
        className={classes.actionIcon}
      >
        <PlusCircleIcon />
      </SvgIcon>
      Add Society
    </Button>
  </Grid>
</Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;